import { DEFAULT_REGION_CODE, REGIONS_ARRAY } from '@/data'

export const fields = `
  _id,
  _type,
  "title": select(
    ${REGIONS_ARRAY.map(code => `$language == "${code}" => ${code}Title`).join(',\n    ')},
    ${DEFAULT_REGION_CODE}Title
  )
`

export const fragment = (name = 'giftCardCategory') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
